import { useQuery } from 'react-query'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'

import {
  fetchTeamByUUID,
  GetTeamQueryParams,
} from '@dc-shared-web/hooks/api/team/fetchTeamByUUID'

export const useGetTeamByUUID = (params?: GetTeamQueryParams) => {
  const apiClient = useAxiosContext()

  return useQuery(
    `team-${params?.teamUUID}`,
    () => fetchTeamByUUID(apiClient, params),
    {
      enabled: !!params?.teamUUID,
    }
  )
}
